import { HelpLink } from 'elements/link/HelpLink'
import { Typography } from 'opensolar-ui'
import { useTranslate } from 'react-admin'

const Subtitle = () => {
  const translate = useTranslate()
  return (
    <Typography textVariant="body1" colorHex="#717171">
      {translate(
        "Make your proposal stand out with stories and images of successful projects you've completed. Please ensure that case studies are based on genuine projects completed by your organisation."
      )}
      <HelpLink href="https://support.opensolar.com/hc/en-us/articles/12447973713935-How-to-configure-your-contract-in-OpenSolar" />
    </Typography>
  )
}

export default {
  list: { lazy: () => import('./Testimonials'), component: 'TestimonialList' },
  edit: { lazy: () => import('./Testimonials'), component: 'TestimonialEdit' },
  create: { lazy: () => import('./Testimonials'), component: 'TestimonialCreate' },
  options: {
    create: {
      title: <Typography textVariant="h5SemiBold">Create Case Study</Typography>,
      subtitle: <Subtitle />,
      breadCrumb: 'Create Case Study',
    },
    list: {
      title: <Typography textVariant="h5SemiBold">Case Studies</Typography>,
      subtitle: <Subtitle />,
      breadCrumb: 'Case Studies',
    },
    edit: {
      title: <Typography textVariant="h5SemiBold">Edit Case Study</Typography>,
      subtitle: <Subtitle />,
      breadCrumb: 'Edit Case Study',
    },
  },
}
